import { NgModule } from '@angular/core';
import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { SharedModule } from "app/modules/shared/shared.module";
import { AdvisorComponent } from './advisor.component';

@NgModule({
    imports: [
        //NgbModule,
        NWMControls,
        SharedModule.forRoot(),
        AdvisorComponent
    ],
    exports: [],
    providers: []
})
export class AdvisorModule { }
